import { Component, Input, OnInit } from '@angular/core';
import { Country } from '../../../shared/types/country.model';
import { Language } from '../../types/helpers/language.model';

@Component({
  selector: 'mmb-web-app-user-languages-locations-info',
  templateUrl: './user-languages-locations-info.component.html',
  styleUrls: ['./user-languages-locations-info.component.scss']
})
export class UserLanguagesLocationsInfoComponent implements OnInit {
  @Input() languages: Language[];
  @Input() nationalities: Country[] = [{
    name: 'American',
    code: 'us',
    id: 1,
    value: 1
  }, {
    name: 'Jamaican',
    code: 'jm',
    id: 2,
    value: 2
  }];

  @Input() locations: any[] = [{
    city: 'Paris',
    country: 'France',
    code: 'fr'
  }, {
    city: 'Maiudguri',
    country: 'Nigeria',
    code: 'ng'
  }, {
    city: 'London',
    country: 'United Kingdom',
    code: 'gb'
  }];

  constructor() { }

  ngOnInit() {
  }

}
